<template>
  <div class="home">
    <Navtop />
    <Index v-show="currentPage == 0" />
    <Login ref="login" v-show="currentPage == 1" />
    <Read v-show="currentPage == 2" />
    <Check v-show="currentPage == 3" />
    <Info v-show="currentPage == 4" />
    <Confirm v-show="currentPage == 5" />
    <Pay ref="pay" v-show="currentPage == 6" />
    <div class="pop" v-if="popShow">
      <div class="help_pop" v-if="popShow == 'help'">
        <i class="close" @click="popShow = ''"></i>
        <span class="title">如何绑定手机号</span>
        <div class="tip_img"></div>
      </div>
      <div class="public_pop history_pop" v-if="popShow == 'history'">
        <i class="close" @click="popShow = ''"></i>
        <span class="title">转移记录查询</span>
        <div class="tab_box">
          <span>申请时间</span>
          <span>转出</span>
          <span>转入</span>
          <span>状态</span>
        </div>
        <div class="history_list">
          <div
            class="history_item"
            v-for="(item, index) in historyArr"
            :key="index"
          >
            <span>{{ item.time }}</span>
            <span>{{ item.transout }}</span>
            <span>{{ item.transin }}</span>
            <span v-if="item.status == 0" style="color: #3e73fe">进行中</span>
            <span v-else>已完成</span>
          </div>
        </div>
      </div>
      <div class="public_pop tip_pop" v-if="popShow == 'transform'">
        <i class="close" @click="popShow = ''"></i>
        <span class="title">是否进行覆盖转移</span>
        <span class="text"
          >经检测，您转移的目标平台已有角色，转移后将覆盖目标平台所有角色，您是否确认转移！</span
        >
        <div class="btn" @click="goPay">确认</div>
      </div>
      <div class="public_pop tip_pop" v-if="popShow == 'checktransform'">
        <!-- <i class="close" @click="popShow = ''"></i> -->
        <span class="title">转移提示</span>
        <span class="text">当前登录的查询账号是否要进行转移</span>
        <div class="trans_btn">
          <div class="btn" @click="goTrans(1)">是</div>
          <div class="btn" @click="goTrans(2)">否</div>
        </div>
      </div>
      <div class="public_pop tip_pop" v-if="popShow == 'tip'">
        <span class="title">提示</span>
        <span class="text">{{ tipText }}</span>
        <div class="btn" @click="popShow = ''">确认</div>
      </div>
    </div>
    <checkLogin v-show="loginShow" />
  </div>
</template>

<script>
import Navtop from '../components/childcomponents/Navtop.vue';
import Index from '../components/Index.vue';
import Login from '../components/Login.vue';
import Read from '../components/Read.vue';
import Check from '../components/Check.vue';
import Confirm from '../components/Confirm.vue';
import Info from '../components/Info.vue';
import Pay from '../components/Pay.vue';
import checkLogin from '../components/checkLogin.vue';
export default {
  components: {
    Index,
    Login,
    Read,
    Check,
    Info,
    Confirm,
    Pay,
    checkLogin,
    Navtop
  },
  data() {
    return {
      canTip: false, //判断是否需要清除查询登录
      loginShow: false, //查询登录弹窗
      system: 1, //1 ios 2 android
      openId: '',
      payToken: '',
      token: '',
      deviceId: '',
      cert: '',
      user: '',
      userid: '',
      tipText: '',
      popShow: '',
      currentPage: 0,
      loginStatus: false,
      historyArr: [
        // {
        //   time: '2023-8-30',
        //   transout: '安卓',
        //   transin: 'iOS',
        //   status: 1
        // },
      ]
    };
  },
  computed: {},
  watch: {
    loginStatus: function () {
      if (!this.loginStatus) {
        this.system = 1;
        this.user = '';
        this.userid = '';
      }
    }
  },
  methods: {
    // 时区
    getLocalTime(i) {
      //参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
      if (typeof i !== 'number') return;
      var d = new Date();
      //得到1970年一月一日到现在的秒数
      var len = d.getTime();
      //本地时间与GMT时间的时间偏移差
      var offset = d.getTimezoneOffset() * 60000;
      //得到现在的格林尼治时间
      var utcTime = len + offset;
      return new Date(utcTime + 3600000 * i);
    },
    goPay() {
      this.currentPage++;
      this.popShow = '';
    },
    wxPay(option) {
      let isQa = /^(test-|qa-|10.)/.test(location.hostname);
      let _this = this;
      let defaults = {
        debug: false,
        appId: 27,
        ext1: '8_1',
        ext2: location.href.split('#')[0],
        title: '',
        link: location.href,
        imgUrl: '',
        desc: ''
      };
      defaults = Object.assign({}, defaults, option);
      $.ajax({
        url:
          `//activity${isQa ? 'test' : ''}.zlongame.com` +
          '/activity/common/handle/share.do',
        data: {
          appId: defaults.appId,
          ext1: defaults.ext1,
          ext2: defaults.ext2
        },
        dataType: 'jsonp',
        jsonp: 'pd_acti_cb',
        jsonpCallback: 'jsonpmobile' + ('' + +new Date()).substr(-4)
      }).done(function (data, status, xhr) {
        if (data.data.success) {
          let share = data.data.info.share;
          wx.config({
            debug: defaults.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: share.appId, // 必填，公众号的唯一标识
            timestamp: share.timestamp, // 必填，生成签名的时间戳
            nonceStr: share.nonceStr, // 必填，生成签名的随机串
            signature: share.signature, // 必填，签名，见附录1
            jsApiList: [
              'chooseWXPay',
              'onMenuShareAppMessage',
              'updateAppMessageShareData',
              'updateTimelineShareData'
            ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            openTagList: ['wx-open-launch-app']
          });
          wx.ready(function () {
            wx.onMenuShareTimeline({
              title: defaults.title, // 分享标题
              link: defaults.link, // 分享链接
              imgUrl: defaults.imgUrl, // 分享图标
              success: function () {
                // 用户确认分享后执行的回调函数
              },
              cancel: function () {
                // 用户取消分享后执行的回调函数
              }
            });
            wx.onMenuShareAppMessage({
              title: defaults.title, // 分享标题
              link: defaults.link, // 分享链接
              imgUrl: defaults.imgUrl, // 分享图标
              desc: defaults.desc,
              success: function () {
                // 用户确认分享后执行的回调函数
              },
              cancel: function () {
                // 用户取消分享后执行的回调函数
              }
            });
            wx.error(function (res) {
              console.log(res);
              // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            });
          });
        }
      });
    },
    is_weixin() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
      } else {
        return false;
      }
    },
    getParams() {
      let url = location.search;
      let p = {};
      if (url.indexOf('?') == 0 && url.indexOf('=') > 0) {
        url = url.substring(1);
        var str = url.split('&');
        for (var i = 0; i < str.length; i++) {
          p[str[i].split('=')[0]] = decodeURIComponent(str[i].split('=')[1]);
        }
      }
      return p;
    },
    goTrans(val) {
      if (val == 1) {
        this.currentPage = 1;
      } else {
        this.loginStatus = false;
        this.currentPage = 1;
      }
      this.popShow = '';
    },
    getTip(val) {
      this.tipText = val;
      this.popShow = 'tip';
    }
  },
  created() {
    if (this.is_weixin()) {
      let isQa = /^(test-|qa-|10.)/.test(location.hostname);
      let openId = this.getParams().openId;
      let _t = this.getParams().ts;
      if (_t) {
        if (openId && (this.getLocalTime(8).getTime() - _t) / 1000 <= 10) {
          //存在时间戳和openid参数，检查时间戳是否超过10秒，
          this.openId = openId;
          this.wxPay({
            appId: 27,
            title: '梦站账号转移系统',
            desc: '',
            imgUrl:
              'https://media.zlongame.com/media/pictures/cn/recharge/share.png',
            link: location.href.split('?')[0]
          });
        } else {
          //超过10秒重新发起授权连接
          let qaFlag = isQa ? 'test' : '';
          window.location =
            'http://mp' +
            qaFlag +
            '.zlongame.com/wx-service/wxcomment/' +
            1486458782785 +
            '/authorize?t=' +
            +new Date() +
            `&homeUrl=${location.href}`;
        }
      } else {
        let qaFlag = isQa ? 'test' : '';
        window.location =
          'http://mp' +
          qaFlag +
          '.zlongame.com/wx-service/wxcomment/' +
          1486458782785 +
          '/authorize?t=' +
          +new Date() +
          `&homeUrl=${location.href}`;
      }
    }
    if (this.getParams().data) {
      let data = this.getParams().data;
      let Base64 = require('js-base64').Base64;
      let info = JSON.parse(Base64.decode(data));
      this.currentPage = 6;
    }
    if (!localStorage.getItem('deviceId')) {
      let randomNum = 'web_' + Math.random().toFixed(40).substr(2, 40);
      localStorage.setItem('deviceId', randomNum);
      this.deviceId = randomNum;
    } else {
      this.deviceId = localStorage.getItem('deviceId');
    }
  },
  mounted() {}
};
</script>
<style lang='less'>
.home {
  width: 7.5rem;
  height: 100%;
  .page {
    width: 7.5rem;
    height: 100%;
    box-sizing: border-box;
    background: #f1f5f6;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 1.78rem;
    overflow: auto;
    .btn_box {
      flex-shrink: 0;
      width: 6.94rem;
      height: 0.9rem;
      margin-top: 0.78rem;
      margin-bottom: 1.2rem;
      display: flex;
      justify-content: space-between;
      div {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      div:nth-child(1) {
        width: 3.27rem;
        height: 0.9rem;
        background: #feffff;
        border: 0.03rem solid #3e73fe;
        border-radius: 0.08rem;
        font-size: 0.32rem;
        font-weight: bold;
        color: #3e73fe;
      }
      div:nth-child(2) {
        width: 3.27rem;
        height: 0.9rem;
        background: #3e73fe;
        border-radius: 0.08rem;
        font-size: 0.32rem;
        font-weight: bold;
        color: #ffffff;
      }
      .no_next {
        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -o-filter: grayscale(100%);
        filter: grayscale(100%);
      }
    }
  }
  .pop {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    background: rgba(0, 0, 0, 0.8);
    .layout-flex(@r,@c,@c);
    .help_pop {
      width: 6.85rem;
      height: 5.02rem;
      background: #ffffff;
      border-radius: 0.2rem;
      position: relative;
      .layout-flex(@col,normal,@c);
      .close {
        width: 0.5rem;
        height: 0.5rem;
        background: url('../assets/close.png');
        background-size: 100% 100%;
        position: absolute;
        right: 0.12rem;
        top: 0.12rem;
      }
      .title {
        font-weight: 500;
        color: #1b1919;
        font-size: 0.32rem;
        margin-top: 0.46rem;
        margin-bottom: 0.36rem;
      }
      .tip_img {
        width: 6.55rem;
        height: 3.58rem;
        background: url('../assets/tip_img.png');
        background-size: 100% 100%;
      }
    }
    .public_pop {
      width: 6.85rem;
      height: 4.26rem;
      background: #ffffff;
      border-radius: 0.2rem;
      position: relative;
      .layout-flex(@col,normal,@c);
      .close {
        width: 0.5rem;
        height: 0.5rem;
        background: url('../assets/close.png');
        background-size: 100% 100%;
        position: absolute;
        right: 0.12rem;
        top: 0.12rem;
      }
      .title {
        font-weight: 500;
        color: #1b1919;
        font-size: 0.32rem;
        margin-top: 0.48rem;
      }
      .text {
        color: #656565;
        font-size: 0.24rem;
        margin-top: 0.5rem;
      }
      .btn {
        width: 3.27rem;
        height: 0.9rem;
        background: #3e73fe;
        border-radius: 0.08rem;
        .layout-flex(@r,@c,@c);
        font-size: 0.32rem;
        color: #fff;
        font-weight: bold;
        margin-top: 0.6rem;
      }
    }
    .history_pop {
      .tab_box {
        width: 6.02rem;
        height: 0.6rem;
        background: #ecf6ff;
        .layout-flex(@r,@b,@c);
        // padding: 0 0.48rem;
        box-sizing: border-box;
        margin-top: 0.33rem;
        span {
          flex: 1;
          .layout-flex(@r,@c,@c);
          color: #1b1919;
          font-size: 0.24rem;
        }
      }
      .history_list {
        width: 6.02rem;
        height: 1.83rem;
        overflow: auto;
        .layout-flex(@col,normal,normal);
        .history_item {
          flex-shrink: 0;
          width: 6.02rem;
          height: 0.6rem;
          border-bottom: 0.01rem solid #dddede;
          .layout-flex(@r,@c,@c);
          span {
            flex: 1;
            .layout-flex(@r,@c,@c);
            color: #656565;
            font-size: 0.24rem;
          }
        }
      }
    }
    .tip_pop {
      padding: 0 0.56rem;
      box-sizing: border-box;
      .trans_btn {
        width: 5rem;
        display: flex;
        justify-content: space-between;
        .btn {
          width: 2.27rem;
          height: 0.6rem;
          background: #3e73fe;
          border-radius: 0.08rem;
          .layout-flex(@r,@c,@c);
          font-size: 0.32rem;
          color: #fff;
          font-weight: bold;
          margin-top: 0.6rem;
        }
      }
    }
    .login_pop {
      width: 100%;
      height: 100vh;
    }
  }
}
</style>
